import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-partnereula',
    templateUrl: './partnereula.component.html',
    styleUrls: ['./partnereula.component.scss'],
    standalone: false,
})
export class PartnerEulaComponent implements OnInit {
    acceptEula: () => void;

    constructor(private dialog: MatDialog) {}

    closeBtnAction = () => {
        this.dialog.closeAll();
    };

    ngOnInit() {}
}
